import React from 'react';

/**
 * 金额输入组件
 * 支持 +/- 按钮和直接输入
 */
export default function AmountInput({ value, onChange, min = 1, max = 10000 }) {
  const handleDecrease = () => {
    const newValue = Math.max(min, value - 1);
    onChange(newValue);
  };

  const handleIncrease = () => {
    const newValue = Math.min(max, value + 1);
    onChange(newValue);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value.replace(/[^\d]/g, '');
    const numValue = inputValue ? parseInt(inputValue) : '';
    onChange(numValue);
  };

  return (
    <div className="flex items-center justify-center gap-0.5">
      <button
        type="button"
        className="w-7 h-7 flex items-center justify-center rounded bg-white/10 border border-white/20 text-lg text-white hover:bg-white/20"
        onClick={handleDecrease}
      >
        -
      </button>
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        className="w-16 h-7 px-2 text-sm bg-white/10 border border-white/20 rounded text-white text-center appearance-none outline-none"
        placeholder="Amount"
      />
      <button
        type="button"
        className="w-7 h-7 flex items-center justify-center rounded bg-white/10 border border-white/20 text-lg text-white hover:bg-white/20"
        onClick={handleIncrease}
      >
        +
      </button>
    </div>
  );
}
